// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')
// Other Components

// Management
const DupeGroupList = () => import('@/modules/duplicates/views/management/DupeGroupList')
const OwnershipRequestList = () => import('@/modules/duplicates/views/OwnershipRequestList')
const OwnershipRequestDetail = () => import('@/modules/duplicates/views/OwnershipRequestDetail')
const OwnershipResolvedList = () => import('@/modules/duplicates/views/OwnershipResolvedList')

var routes = [
    {
        path: '/dupe-groups/manage',
        redirect: '/dupe-groups/manage/list',
        component: DefaultContainer,
        children: [
            {
                path: 'list',
                name: 'DupeGroupList',
                component: DupeGroupList,
            },
        ]
    },
    {
        path: '/ownership-requests',
        redirect: '/ownership-requests/list',
        component: DefaultContainer,
        children: [
            {
                path: 'list',
                name: 'OwnershipRequestList',
                component: OwnershipRequestList,
            },
            {
                path: 'resolved',
                name: 'OwnershipResolvedList',
                component: OwnershipResolvedList,
            },
            {
                path: ':ownership_request_id',
                name: 'OwnershipRequestDetail',
                component: OwnershipRequestDetail,
            },
        ]
    },
];

export default routes;
